import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getAllUsersWithoutPagination = () => {
    return vdkEmHappinessPortalApi.get('/users/get-all-without-pagination');
};
const getAllUsersPaginated = (request) => {
    return vdkEmHappinessPortalApi.post('/users/get-paginated-all', request);
};
const createUser = (request) => {
    const formData = new FormData();
    formData.append('Id', request.id || '');
    formData.append('FirstName', request.firstName);
    formData.append('LastName', request.lastName);
    formData.append('Email', request.email);
    formData.append('PhoneNo', request.phoneNo);
    if (request.profilePicture) {
        formData.append('ProfilePicture', request.profilePicture);
    }
    formData.append('PrimaryCompanyId', request.primaryCompanyId);
    if (request.primaryLanguageId) {
        formData.append('PrimaryLanguageId', request.primaryLanguageId);
    }
    // Append arrays
    request.companyIds.forEach((companyId, index) => {
        formData.append(`CompanyIds[${index}]`, companyId);
    });
    request.roles.forEach((role, index) => {
        formData.append(`Roles[${index}].Id`, role.id);
        formData.append(`Roles[${index}].Name`, role.name);
        formData.append(`Roles[${index}].CompanyId`, role.companyId);
    });
    return vdkEmHappinessPortalApi.post('/users/create-user', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const updateUser = (request) => {
    // If there's a profile picture, use FormData
    const formData = new FormData();
    formData.append('Id', request.id || '');
    formData.append('FirstName', request.firstName);
    formData.append('LastName', request.lastName);
    formData.append('Email', request.email);
    formData.append('PhoneNo', request.phoneNo);
    if (request.profilePicture) {
        formData.append('ProfilePicture', request.profilePicture);
    }
    formData.append('PrimaryCompanyId', request.primaryCompanyId);
    if (request.primaryLanguageId) {
        formData.append('PrimaryLanguageId', request.primaryLanguageId);
    }
    // Append arrays
    request.companyIds.forEach((companyId, index) => {
        formData.append(`CompanyIds[${index}]`, companyId);
    });
    request.roles.forEach((role, index) => {
        formData.append(`Roles[${index}].Id`, role.id);
        formData.append(`Roles[${index}].Name`, role.name);
        formData.append(`Roles[${index}].CompanyId`, role.companyId);
    });
    return vdkEmHappinessPortalApi.post('/users/update-user', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const getUserWithRolesById = (userId) => {
    return vdkEmHappinessPortalApi.get(`/users/get-with-roles/${userId}`);
};
export const updateUserStatusApi = async (payload) => {
    return vdkEmHappinessPortalApi.post('/users/toggle-active', payload);
};
const getAllUsersByCompanyApi = (companyIds) => {
    return vdkEmHappinessPortalApi.post('/users/get-all-users-by-company', {
        companyIds: companyIds
    });
};
const UserApi = {
    getAllUsersWithoutPagination,
    getAllUsersPaginated,
    getAllUsersByCompanyApi,
    createUser,
    updateUser,
    getUserWithRolesById,
    updateUserStatusApi
};
export default UserApi;
